import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ee94edc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nav-bar" }

import { RouteRecordRaw, useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const router = useRouter()
/**
 * 显示逻辑
 * 只支持二级路有，三级路由以上需修改显示逻辑
 * 过滤掉不需要显示的 menu 和 未授权页面
 */
const menus: RouteRecordRaw[] = [];
router.options.routes.forEach((router: RouteRecordRaw) => {
    if (router?.meta?.requiresAuth && !router?.meta?.hidden) {
        const { children } = router;
        if (children) {
            router['children'] = children.filter((childRouter: RouteRecordRaw) => childRouter?.meta?.requiresAuth && !childRouter?.meta?.hidden)
        }
        menus.push(router)
    }
})

const resolvePath = (name: any) => {
    return router.resolve({ name })?.fullPath
}


return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_menu, {
      router: "",
      mode: "horizontal",
      class: "menu",
      "active-text-color": "#40faff",
      "background-color": "#33335b",
      "text-color": "#fff",
      "default-active": resolvePath(_ctx.$route.name)
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(menus, (menu) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: menu.name
          }, [
            (menu?.children?.length === 1)
              ? (_openBlock(), _createBlock(_component_el_menu_item, {
                  key: menu.name,
                  index: resolvePath(menu.name)
                }, {
                  title: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(menu?.meta?.title), 1)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, { size: "14" }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createBlock(_resolveDynamicComponent(menu?.meta?.icon)))
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["index"]))
              : (_openBlock(), _createBlock(_component_el_sub_menu, {
                  key: resolvePath(menu.name),
                  index: resolvePath(menu.name)
                }, {
                  title: _withCtx(() => [
                    _createVNode(_component_el_icon, { size: "14" }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createBlock(_resolveDynamicComponent(menu?.meta?.icon)))
                      ]),
                      _: 2
                    }, 1024),
                    _createElementVNode("span", null, _toDisplayString(menu?.meta?.title), 1)
                  ]),
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menu?.children, (child) => {
                      return (_openBlock(), _createBlock(_component_el_menu_item, {
                        index: resolvePath(child.name),
                        key: child.name
                      }, {
                        title: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(child?.meta?.title), 1)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_icon, { size: "14" }, {
                            default: _withCtx(() => [
                              (_openBlock(), _createBlock(_resolveDynamicComponent(child?.meta?.icon)))
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["index"]))
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["index"]))
          ], 64))
        }), 64))
      ]),
      _: 1
    }, 8, ["default-active"])
  ]))
}
}

})